import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { StatusState } from "store/types";
import { fetchEventList } from "./eventList.actions";
import { EventListState, FetchEventListResponse } from "./EventList.types";

const initialState: EventListState = {
  data: [],
  pagination: {
    total_pages: 0,
    current_page: 0,
  },
  status:StatusState.IDLE,
  error: null,
};

const eventListSlice = createSlice({
  name: "eventList",
  initialState,
  reducers: {
    setEventList: (state, action: PayloadAction<FetchEventListResponse>) => {
      state.data = action.payload.data;
      state.pagination = {...state.pagination, ...action.payload.pagination}
    },
    // opcional: para resetear la lista
    resetEventList: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEventList.pending, (state) => {
        state.status = StatusState.LOADING;
        state.error = null;
      })
      .addCase(fetchEventList.fulfilled, (state) => {
        state.status = StatusState.SUCCEEDED;
        state.error = null;
      })
      .addCase(fetchEventList.rejected, (state, action) => {
        state.status = StatusState.FAILED;
        if (typeof action.payload === "string") {
          state.error = action.payload;
        } else {
          state.error = "An unexpected error occurred";
        }
      });
  },
});

export const { setEventList, resetEventList } = eventListSlice.actions;
const eventListReducer  = eventListSlice.reducer;
export default eventListReducer

